import { render, staticRenderFns } from "./gCartListHeader.vue?vue&type=template&id=87db6072&scoped=true&"
import script from "./gCartListHeader.vue?vue&type=script&lang=js&"
export * from "./gCartListHeader.vue?vue&type=script&lang=js&"
import style0 from "./gCartListHeader.vue?vue&type=style&index=0&id=87db6072&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87db6072",
  null
  
)

export default component.exports